import React, { useCallback } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { useModal } from '../../../hooks/useModal';
import { useTranslation } from '../../../translations';

const TextModal = React.forwardRef(function TextModal({ back, title, text }, ref) {
  const { closeModal, id } = useModal();
  const { t } = useTranslation();

  const close = useCallback(() => {
    closeModal(id);
  }, [id]);

  return (
    <CustomModal>
      <div className={'text-modal'} ref={ref}>
        <div className={'text-modal__bg'} />
        <div className={'text-modal__content'}>
          <CustomButton {...back.attr} onClick={close} />
          <h2 className={'text-modal__title'}>{safeHTML(t(title))}</h2>
          <p className={'text-modal__text'}>{safeHTML(t(text))}</p>
        </div>
      </div>
    </CustomModal>
  );
});
export default TextModal;
TextModal.propTypes = {};
